import OrdersTable from "components/Admin/Tables/OrdersTable";
import React from "react";
import styled from "styled-components/macro";
import Widget from "../Widget";

interface OrdersProps {}

const Orders: React.FC<OrdersProps> = ({}) => {
  return (
    <Widget title="Поръчки">
      <OrdersTable />
    </Widget>
  );
};

const OrdersContainer = styled.div``;

export default Orders;
